function setupAutoHide(element) {
  var lastScrollTop = 0;
  function updateAutoHide() {
    var elementHeight = element.offsetHeight;
    var scrollTop = window.scrollY;
    if (scrollTop < lastScrollTop) {
      element.classList.remove('scrolled-down');
      element.classList.add('scrolled-up');
      if (scrollTop == 0) {
        element.classList.remove('fixed-top');
        document.body.style.paddingTop = 0;
      } else {
        element.classList.add('fixed-top');
        document.body.style.paddingTop = elementHeight + 'px';
      }
    } else if (scrollTop > elementHeight) {
      element.classList.remove('scrolled-up');
      element.classList.add('scrolled-down');
    }
    lastScrollTop = scrollTop;
  }

  window.addEventListener('scroll', updateAutoHide);
}

function setupWave(element) {
  var spacer = document.createElement('div');
  spacer.className = 'wave-spacer';
  element.insertBefore(spacer, element.firstChild);

  function updateWave() {
    var elementRect = element.getBoundingClientRect();
    var width = elementRect.width;
    var pageHeight = document.body.clientHeight;
    var waveHeight = element.dataset.waveHeight
      ? parseInt(element.dataset.waveHeight)
      : Math.min(width * 0.1, 100);
    spacer.style.setProperty('height', `${waveHeight}px`);
    element.style.setProperty('margin-top', `-${waveHeight}px`);
    var pathCommands = [
      `M 0,${waveHeight}`,
      `Q ${width * 0.2},0 ${width * 0.5},${waveHeight * 0.5}`,
      `S ${width * 0.75},${waveHeight} ${width},${0}`,
      `L ${width},${pageHeight}`,
      `L 0,${pageHeight}`,
    ];
    element.style.setProperty('clip-path', `path("${pathCommands.join(' ')}")`);
  }

  updateWave();
  window.addEventListener('resize', updateWave);
}

function setupInteriorHeader(element) {
  var focalPointX = element.dataset.focalPointX
    ? parseFloat(element.dataset.focalPointX) * 100
    : '50';
  var focalPointY = element.dataset.focalPointY
    ? parseFloat(element.dataset.focalPointY) * 100
    : '0';
  element.style.setProperty(
    'background-position',
    `${focalPointX}% ${focalPointY}%`
  );

  var navHeight = document.querySelector('.navbar-container').offsetHeight;
  function updateInteriorHeader() {
    var scroll = window.scrollY || window.pageYOffset;
    var fixedScroll = Math.min(
      Math.max(scroll - navHeight, 0),
      element.offsetHeight
    );
    element.style.setProperty(
      'transform',
      `translate3d(0, ${fixedScroll}px, 0)`
    );
  }

  updateInteriorHeader();
  window.addEventListener('scroll', updateInteriorHeader);
}

function setupPageEnterAnimations() {
  document.body.classList.add('page-enter-active');
  setTimeout(function () {
    document.body.classList.remove('page-enter');
    document.body.classList.remove('page-enter-active');
  }, 500);
}

function setupScrollAnimations() {
  AOS.init({ easing: 'ease-out' });

  let aosDisabled = false;
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab' && !aosDisabled) {
      aosDisabled = true;
      // This isn't ideal but the `disable` option in AOS
      // triggers a bunch of errors on scroll.
      setup('[data-aos]', function (element) {
        element.removeAttribute('data-aos');
        element.removeAttribute('data-aos-easing');
        element.removeAttribute('data-aos-duration');
        element.removeAttribute('data-aos-delay');
      });
    }
  });
}

function setup(selector, fn) {
  var elements = document.querySelectorAll(selector);
  Array.prototype.forEach.call(elements, function (element) {
    fn(element);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setup('.auto-hide', setupAutoHide);
  setup('.wave', setupWave);
  setup('.new-interior-header', setupInteriorHeader);
  setupPageEnterAnimations();
});

setupScrollAnimations();
